import { useQuery } from "@tanstack/react-query";
import SiteService from "services/SiteService";

export const useRefreshSite = (queryOptions = {}) => {
  return useQuery({
    queryKey: ["refresh"],
    queryFn: () => SiteService.refresh(),
    ...queryOptions,
  });
};

export const useGetAllSites = (queryOptions = {}) => {
  return useQuery({
    queryKey: ["getSites"],
    queryFn: SiteService.getAllSites,
    ...queryOptions,
  });
};

export const useGetSite = (siteName, queryOptions = {}) => {
  return useQuery({
    queryKey: ["getSite", siteName],
    queryFn: () => SiteService.get(siteName),
    ...queryOptions,
  });
};
